import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutStatusDurationReport extends Layout {
    checkboxPageBreak: Checkbox;
    excludabletextboxCarrier: ExcludableTextbox;
    excludabletextboxCustSaleperson: ExcludableTextbox;
    excludabletextboxCustomer: ExcludableTextbox;
    excludabletextboxDispatcher: ExcludableTextbox;
    excludabletextboxInboundLookup: ExcludableTextbox;
    excludabletextboxOrderType: ExcludableTextbox;
    excludabletextboxOutbountLookup: ExcludableTextbox;
    excludabletextboxRevenueCode: ExcludableTextbox;
    sourceStatusDurations: DataSource;
    switchReport: Switch;
    switchSortBy: Switch;
    switchStatusDuration: Switch;
    switchinludeLtlOrder: Switch;
    textboxBrokerageStatus: Textbox;
    textboxGroupBy: Textbox;
    textboxInboundTo: Textbox;
    textboxMinute: Textbox;
    textboxMovStatus: Textbox;
    textboxOutbondFrom: Textbox;
    textboxshipDate: Textbox;
}
